import { axios_requer, axios_export } from "../axios/http_axios";

// 参数有这些,需要的就填,不写就用默认值

// path,
// params = {},
// method = 'POST',  //  POST / GET
// headerType = '',  //   json 和 "" 两种
// isShowLoading = true,  //是否显示加载中
// istips = true,        //是否弹窗
// hasSing = false,      //是否有签名

let hasSing = true; //需要签名的加上这个
let method = "GET"; //需要GET请求的加上这个
let headerType = "json"; //需要JSON格式的加上这个

// ————————待配载————————
export default {
  // 校验任务是否包含冲突品类
  async checkTaskHasClashItem(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/checkTaskHasClashItem",
      params,
      headerType,
    }).then((res) => res);
  },
  // 确认配载
  async createDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/createDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 批次任务排序导入预览
  async importDispatchTaskSortV3(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importDispatchTaskSortV3",
      params,
      headerType,
    }).then((res) => res);
  },
  // 导入批次任务排序数据校验
  async importDispatchTaskSortCheckV3(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importDispatchTaskSortCheckV3",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 确认导入批次任务排序数据
  async importDispatchTaskSortSureV3(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importDispatchTaskSortSureV3",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  // ————————动态查询————————
  // 获取动态查询列表
  async getQueryList(params) {
    return await axios_requer({
      path: "/v1/common/query/getQueryList",
      params,
      method,
    }).then((res) => res);
  },
  // 获取动态查询条件
  async getReportConditions(params) {
    return await axios_requer({
      path: "/v1/common/query/getReportConditions",
      params,
      method,
    }).then((res) => res);
  },
  // 获取动态查询展示字段
  async getReportFileds(params) {
    return await axios_requer({
      path: "/v1/common/query/getReportFileds",
      params,
      method,
    }).then((res) => res);
  },
  // 获取动态查询展示字段
  async getReportFiledsV2(params) {
    return await axios_requer({
      path: "/v1/common/query/getReportFiledsV2",
      params,
      headerType,
    }).then((res) => res);
  },
  // 执行动态查询sql(分页)
  async runPageReport(params) {
    return await axios_requer({
      path: "/v1/common/query/runPageReport",
      params,
      headerType,
    }).then((res) => res);
  },
  // 执行动态查询sql(不分页) 详情
  async runPageReportDetails(params) {
    return await axios_requer({
      path: "/v1/common/query/runReport",
      params,
      headerType,
    }).then((res) => res);
  },

  //————————提货指令————————
  // 新建提货指令
  async commandaddCommand(params) {
    return await axios_requer({
      path: "/admin/v4/tms/command/addCommand",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改提货指令
  async commandupdateCommand(params) {
    return await axios_requer({
      path: "/admin/v4/tms/command/updateCommand",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 删除提货指令
  async commanddelCommand(params) {
    return await axios_requer({
      path: "/admin/v4/tms/command/delCommand",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //————————外发管理————————
  // 外发录入前详情(荣祥版)
  async outgoinggetOutgoingBeforeDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/getOutgoingBeforeDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //外发录入(荣祥版)
  async outgoingaddOutgoingBill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/addOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 外发详情(荣祥版)
  async outgoinggetOutgoingDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/getOutgoingDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //修改外发(荣祥版)
  async outgoingupdateOutgoingBill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/updateOutgoingBill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //批量过账
  async outgoingbatchPosting(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/batchPosting",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //批量重算
  async batchFormulaFreight(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/batchFormulaFreight",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //————————不合格服务调查与处置表 ————————
  //新建不合格服务
  async rectifyaddRectify(params) {
    return await axios_requer({
      path: "/admin/v4/exception/rectify/addRectify",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //修改不合格服务
  async rectifyupdateRectify(params) {
    return await axios_requer({
      path: "/admin/v4/exception/rectify/updateRectify",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //————————调度————————
  //提货调度-单票派车
  async takeoneDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/take/oneDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //送货调度-单票派车
  async sendoneDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/send/oneDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //送货调度-多票派车
  async sendmoreDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/send/moreDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //外发调度-外发派车
  async waifaoneDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/waifa/oneDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //接收调度员-新增
  async addDispatchUser(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/user/addDispatchUser",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //接收调度员-新增
  async updateDispatchUser(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/user/updateDispatchUser",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //接收调度员-删除
  async delDispatchUser(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/user/delDispatchUser",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运单配载 - 外发
  async waybillwaiFa(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/waybill/waiFa",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运单配载 - 直送
  async waybillzhiSong(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/waybill/zhiSong",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运单配载 - 转仓
  async waybillzhuanCang(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/waybill/zhuanCang",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运单配载 - 详情
  async getWaybillDispatchDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/waybill/getWaybillDispatchDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //运单配载 - 修改配载
  async updateWaybillDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/waybill/updateWaybillDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运输跟踪- 获取运输跟踪
  async getTrackTransportList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/track/getTrackTransportList",
      params,
      headerType,
    }).then((res) => res);
  },
  //运输跟踪- 获取运输跟踪
  async getTrackTransportListByWaybillNumber(params) {
    return await axios_requer({
      path: "/driver/v4/tms/track/getWaybillTrackTransport",
      params,
      headerType,
    }).then((res) => res);
  },
  //运输跟踪 - 新增运输跟踪
  async addTrackTransport(params) {
    return await axios_requer({
      path: "/admin/v4/tms/track/addTrackTransport",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //分拣单模块 - 分拣(含修改)
  async sortingOrder(params) {
    return await axios_requer({
      path: "/admin/v4/tms/sorting/order/sortingOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //分拣单模块 - 获取分拣单详情
  async sortingOrderDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/sorting/order/sortingOrderDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //财务管理模块  获取核销总表
  async getCustomerFinanceList(params) {
    return await axios_requer({
      path: "/admin/v4/finance/getCustomerFinanceList",
      params,
      method,
    }).then((res) => res);
  },
  //————报销单管理————
  //新建报销单
  async addExpense(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/addExpense",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //批量过账
  async batchPostin(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/batchPostin",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //获取报销单详情
  async getExpenseDetail(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/getExpenseDetail",
      params,
      method,
    }).then((res) => res);
  },
  //获取报销单详情 - 车辆明细
  async getExpenseDetailCar(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/getExpenseDetailCar",
      params,
      method,
    }).then((res) => res);
  },
  //获取报销单详情 -发车明细
  async getExpenseDetailDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/getExpenseDetailDispatch",
      params,
      method,
    }).then((res) => res);
  },
  //获取报销单详情 -外发明细
  async getExpenseDetailOutgoing(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/getExpenseDetailOutgoing",
      params,
      method,
    }).then((res) => res);
  },
  //获取报销单详情 -运单明细
  async getExpenseDetailWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/getExpenseDetailWaybill",
      params,
      method,
    }).then((res) => res);
  },
  //获取报销单列表
  async getExpenseList(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/getExpenseList",
      params,
      method,
    }).then((res) => res);
  },
  //一级审核
  async oneApprove(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/oneApprove",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //报销单过账并返回财务数据
  async postingExpense(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/postingExpense",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //批量反过账
  async rebatchPostin(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/rebatchPostin",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //批量删除
  async delExpense(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/delExpense",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //二级审核
  async twoApprove(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/twoApprove",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //外发列表 新
  async getOutgoingList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/getOutgoingList",
      params,
    }).then((res) => res);
  },
  //修改报销单
  async updateExpense(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/updateExpense",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //报销单核销
  async writeOffExpense(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/writeOffExpense",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常表合并
  async getCustomerExceptionList(params) {
    return await axios_requer({
      path: "/admin/v3/exception/getCustomerExceptionList",
      params,
    }).then((res) => res);
  },
  //配载批次 详情 明细
  async getDispatchDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/getDispatchDetail",
      params,
    }).then((res) => res);
  },
  //配载批次 详情 明细 获取发车批次的任务列表
  async getDispatchTaskList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/getDispatchTaskList",
      params,
      method,
    }).then((res) => res);
  },
  //配载批次 修改 -外发
  async updateWaifaDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/updateWaifaDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //配载批次 修改 -修改直送车次
  async updateSendDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/updateSendDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //配载批次 修改 -修改提货车次
  async updateTakeDispatch(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/updateTakeDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //发票管理 新增开票
  async invoiceaddInvoice(params) {
    return await axios_requer({
      path: "/admin/v4/finance/invoice/addInvoice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //发票管理 开票申请
  async invoiceapplyInvoice(params) {
    return await axios_requer({
      path: "/admin/v4/finance/invoice/applyInvoice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //发票管理 取消开票确认
  async invoicecancelInvoiceSure(params) {
    return await axios_requer({
      path: "/admin/v4/finance/invoice/cancelInvoiceSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //发票管理 删除发票
  async invoiceadelInvoice(params) {
    return await axios_requer({
      path: "/admin/v4/finance/invoice/delInvoice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //发票管理 获取发票详情
  async invoicegetInvoiceDetail(params) {
    return await axios_requer({
      path: "/admin/v4/finance/invoice/getInvoiceDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //发票管理 开票确认
  async invoiceinvoiceSure(params) {
    return await axios_requer({
      path: "/admin/v4/finance/invoice/invoiceSure",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //发票管理 邮寄发出
  async invoicesendInvoice(params) {
    return await axios_requer({
      path: "/admin/v4/finance/invoice/sendInvoice",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 借支单
  //借支单 新增借支单
  async addDebitNote(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/addDebitNote",
      params,
      headerType,
    }).then((res) => res);
  },
  //借支单 取消转入
  async cancelInV2(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/cancelInV2",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //借支单 取消转出
  async cancelOutV2(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/cancelOutV2",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //借支单 删除借支单
  async deleteRecordV2(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/deleteRecordV2",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //借支单 获取资金调拨(借支单)详情
  async getAllocationRecordDetail(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/getAllocationRecordDetail",
      params,
      method,
    }).then((res) => res);
  },
  //借支单 获取借支单列表
  async getDebitNoteListV2(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/getDebitNoteListV2",
      params,
      method,
    }).then((res) => res);
  },
  //借支单 一级审核
  async noteoneApprove(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/oneApprove",
      params,
      headerType,
    }).then((res) => res);
  },
  //借支单 二级审核
  async notetwoApprove(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/twoApprove",
      params,
      headerType,
    }).then((res) => res);
  },
  //借支单 三级审核
  async notethreeApprove(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/threeApprove",
      params,
      headerType,
    }).then((res) => res);
  },
  //借支单 修改借支单
  async updateDebitNote(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/updateDebitNote",
      params,
      headerType,
    }).then((res) => res);
  },

  //借支单 核销借支单
  async writerOffDebitNote(params) {
    return await axios_requer({
      path: "/admin/v4/finance/debit/note/writerOffDebitNote",
      params,
      headerType,
    }).then((res) => res);
  },

  //承运商 新建承运商
  async carrieraddCarrier(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/addCarrier",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商 修改承运商
  async carrierudpateCarrier(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/udpateCarrier",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商 新建合同
  async carrieraddContract(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/addContract",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商 删除合同
  async carrierdelContract(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/delContract",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商 获取默认收款信息
  async carriergetCollecationAccount(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/getCollecationAccount",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商 获取合同图片
  async carriergetContractPics(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/getContractPics",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商  保存资质信息 获取合同图片
  async filegetFiles(params) {
    return await axios_requer({
      path: "/admin/v4/file/getFiles",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商 保存资质信息
  async saveCarrierQualification(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/saveCarrierQualification",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商 修改合同
  async carrierupdateContract(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/updateContract",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 新建承运商报价
  async addCarrierOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/addCarrierOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 删除承运商报价
  async delCarrierOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/delCarrierOffer",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 启用承运商报价
  async startCarrierOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/startCarrierOffer",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 禁用承运商报价
  async stopCarrierOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/stopCarrierOffer",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 修改承运商报价
  async updateCarrierOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/updateCarrierOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商报价线路列表
  async carriergetLineChannelOfferList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/getLineChannelOfferList",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 新建承运商线路报价
  async carrieraddCarrierLineOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/addCarrierLineOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 删除承运商线路报价
  async carrierdelLineChannelOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/delLineChannelOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 详情承运商线路报价
  async carriergetLineChannelOfferDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/getLineChannelOfferDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //承运商报价 修改承运商线路报价
  async carrierupdateCarrierLineOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/updateCarrierLineOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 新建合同
  async customeraddContract(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/addContract",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 新建客户档案
  async customeraddCustomer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/addCustomer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 删除合同
  async customerdelContract(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/delContract",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 删除客户档案
  async customerdelCustomer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/delCustomer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 获取合同图片
  async customergetContractPics(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/getContractPics",
      params,
      headerType,
    }).then((res) => res);
  },
  //客户档案 客户档案详情
  async customergetCustomerDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/getCustomerDetail",
      params,
      method,
    }).then((res) => res);
  },
  //客户档案 修改客户档案
  async customerudpateCustomer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/udpateCustomer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 修改合同
  async customerupdateContract(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/updateContract",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 客户报价 新增客户报价
  async offeraddCustomerOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/addCustomerOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 客户报价 修改客户报价
  async offerupdateCustomerOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/updateCustomerOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 客户报价 获取客户报价详情
  async offergetChannelDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/getChannelDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //客户档案 客户报价 删除客户报价
  async offerdelChannel(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/delChannel",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 客户报价 列表
  async offergetLineChannelOfferList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/getLineChannelOfferList",
      params,
      headerType,
    }).then((res) => res);
  },
  //客户档案 新增客户线路报价
  async offeraddLineChannelOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/addLineChannelOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 删除客户线路报价
  async offerdelLineChannelOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/delLineChannelOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //客户档案 获取客户线路报价详情
  async offergetLineChannelOfferDetail(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/getLineChannelOfferDetail",
      params,
      headerType,
    }).then((res) => res);
  },
  //客户档案 修改客户线路报价
  async offerupdateLineChannelOffer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/offer/updateLineChannelOffer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //车辆保险v4 新建车辆保险
  async addCarInsurance(params) {
    return await axios_requer({
      path: "/admin/v3/tms/car/insurance/addCarInsurance",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //车辆保险v4 修改车辆保险
  async updateCarInsurance(params) {
    return await axios_requer({
      path: "/admin/v3/tms/car/insurance/updateCarInsurance",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //车辆保险v4 车辆保险详情
  async getCarInsuranceDetail(params) {
    return await axios_requer({
      path: "/admin/v3/tms/car/insurance/getCarInsuranceDetail",
      params,
      method,
    }).then((res) => res);
  },
  //车辆保险v4 删除车辆保险
  async delCarInsurance(params) {
    return await axios_requer({
      path: "/admin/v3/tms/car/insurance/delCarInsurance",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //地址簿v4 修改画像标签
  async updatePortraitLabel(params) {
    return await axios_requer({
      path: "/admin/v4/tms/customer/addr/updatePortraitLabel",
      params,
      hasSing,
    }).then((res) => res);
  },
  //员工管理 开启借支卡
  async startEmployeeJieZhi(params) {
    return await axios_requer({
      path: "/admin/v3/tms/employee/startEmployeeJieZhi",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //保存企业资质信息
  async saveEnterpriseQualification(params) {
    return await axios_requer({
      path: "/admin/v4/tms/qualification/saveEnterpriseQualification",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //修改基础数据配置
  async saveBaseDataInfo(params) {
    return await axios_requer({
      path: "/admin/v4/conf/base/data/saveBaseDataInfo",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 新建异常原因
  async addExceptionReason(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/addExceptionReason",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 新建异常类型
  async addExceptionType(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/addExceptionType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 删除异常原因
  async delExceptionReason(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/delExceptionReason",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 删除异常类型
  async delExceptionType(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/delExceptionType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 异常类型维护左边导航栏
  async getLeftExceptionTypeList(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/getLeftExceptionTypeList",
      params,
      method,
    }).then((res) => res);
  },
  //异常原因v4 启用异常原因
  async startExceptionReason(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/startExceptionReason",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 启用异常类型
  async startExceptionType(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/startExceptionType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 禁用异常原因
  async stopExceptionReason(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/stopExceptionReason",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 禁用异常类型
  async stopExceptionType(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/stopExceptionType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 修改异常原因
  async udpateExceptionReason(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/udpateExceptionReason",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常原因v4 修改异常类型
  async udpateExceptionType(params) {
    return await axios_requer({
      path: "/admin/v4/tms/exception/type/udpateExceptionType",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //承运商运费计算(外发配载运费预估)
  async formulafreightCarrierCalculation(params) {
    return await axios_requer({
      path: "/common/v2/formula/freightCarrierCalculation",
      params,
    }).then((res) => res);
  },
  //根据计费方式获得计费取值
  async billWeightCalculationById(params) {
    return await axios_requer({
      path: "/common/v2/formula/billWeightCalculationById",
      params,
      method,
    }).then((res) => res);
  },
  //生成承运商报价方案明细模板
  async exportCarrierDispatchChannelModel(params) {
    return await axios_export({
      path: "/v4/admin/poi/exportCarrierDispatchChannelModel",
      params,
    }).then((res) => res);
  },
  //生成客户报价方案明细模板
  async exportCustomerDispatchChannelModel(params) {
    return await axios_export({
      path: "/v4/admin/poi/exportCustomerDispatchChannelModel",
      params,
    }).then((res) => res);
  },
  //导入承运商报价方案明细
  async importCarrierChannelDispatch(params) {
    return await axios_requer({
      path: "/v4/admin/poi/importCarrierChannelDispatch",
      params,
      headerType,
    }).then((res) => res);
  },
  //导入客户报价方案明细
  async importCustomerChannelDispatch(params) {
    return await axios_requer({
      path: "/v4/admin/poi/importCustomerChannelDispatch",
      params,
      headerType,
    }).then((res) => res);
  },
  //运单配载 批量外发
  async waybillbatchWaiFa(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/waybill/batchWaiFa",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  //获取单据类型下拉列表
  async getDocumentStatusList(params) {
    return await axios_requer({
      path: "/v4/tms/down/list/getDocumentStatusList",
      params,
    }).then((res) => res);
  },
  //根据单据类型获取单据下拉列表
  async getDocumentBillsList(params) {
    return await axios_requer({
      path: "/v4/tms/down/list/getDocumentBillsList",
      params,
    }).then((res) => res);
  },
  //承运商转正
  async updateCarrierAttribute(params) {
    return await axios_requer({
      path: "/admin/v4/tms/carrier/updateCarrierAttribute",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  //删除其他收入
  async delOtherIn(params) {
    return await axios_requer({
      path: "/admin/v3/finance/other/delOtherIn",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  //删除其他支出
  async delOtherOut(params) {
    return await axios_requer({
      path: "/admin/v3/finance/other/delOtherOut",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  //批量过账其他收入
  async batchPostingOtherIn(params) {
    return await axios_requer({
      path: "/admin/v3/finance/other/batchPostingOtherIn",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  //批量过账其他支出
  async batchPostingOtherOut(params) {
    return await axios_requer({
      path: "/admin/v3/finance/other/batchPostingOtherOut",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  //批量返过账其他收入
  async unPostingOtherIn(params) {
    return await axios_requer({
      path: "/admin/v3/finance/other/unPostingOtherIn",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },
  //批量返过账其他支出
  async unPostingOtherOut(params) {
    return await axios_requer({
      path: "/admin/v3/finance/other/unPostingOtherOut",
      params,
      headerType,
      hasSing,
    }).then((res) => res);
  },

  //导入地址簿
  async importCustomerAddrV4(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importCustomerAddrV4",
      params,
      headerType,
    }).then((res) => res);
  },
  // 获取报销单详情-运单应付
  async getExpenseDetailWaybillFinanceOut(params) {
    return await axios_requer({
      path: "/admin/v4/finance/expense/getExpenseDetailWaybillFinanceOut",
      params,
      method,
    }).then((res) => res);
  },
  // 发车批次过账
  async batchPostingDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/batchPostingDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 设置运输跟踪展示状态
  async updateTrackTransportShow(params) {
    return await axios_requer({
      path: "/admin/v4/tms/track/updateTrackTransportShow",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 修改签收附件
  async updateSignforWaybillFile(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateSignforWaybillFile",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运单-费用录入  修改发车费用
  async waybillupdateSignforWaybillFile(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateDispatchFee",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运单-费用录入 修改外发费用
  async waybillupdateOutgoingFee(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateOutgoingFee",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //外发列表-外发跟踪 签收
  async signforOutgoingWaybill(params) {
    return await axios_requer({
      path: "/admin/v4/tms/outgoing/signforOutgoingWaybill",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 取消发车确认
  async cancelStartCar(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/cancelStartCar",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 取消司机接单
  async cancelReceiveOrder(params) {
    return await axios_requer({
      path: "/admin/v4/tms/dispatch/cancelReceiveOrder",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常列表-修改异常
  async updateException(params) {
    return await axios_requer({
      path: "/admin/v3/exception/updateException",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //运单-提货录入
  async waybillpickupEntry(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/pickupEntry",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  //异常客户导出
  async exportCustomerExceptionList(params) {
    return await axios_requer({
      path: "/admin/v3/exception/exportCustomerExceptionList",
      params,
      headerType,
    }).then((res) => res);
  },
  //运单-修改开单客户
  async updateWaybillCustomer(params) {
    return await axios_requer({
      path: "/admin/v4/tms/waybill/updateWaybillCustomer",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },

  //生成外发单导入模板
  async exportOutgoingModel(params) {
    return await axios_export({
      path: "/v4/admin/poi/exportOutgoingModel",
      params,
    }).then((res) => res);
  },

  // 外发单导入-预览
  async importOutgoingV4(params) {
    return await axios_requer({
      path: '/v4/admin/poi/importOutgoingV4',
      params,
      headerType,
    }).then(res => res);
  },

  // 外发单导入数据校验
  async importOutgoingCheckV4(params) {
    return await axios_requer({
      path: '/v4/admin/poi/importOutgoingCheckV4',
      params,
      headerType,
    }).then(res => res);
  },
  // 导入外发单
  async importOutgoingSureV4(params) {
    return await axios_requer({
      path: '/v4/admin/poi/importOutgoingSureV4',
      params,
      headerType,
    }).then(res => res);
  },

};
